module.exports = __webpack_public_path__ + "static/media/Neutral.74c35116.obj";